require('../css/app.sass')

import 'phoenix_html'
import { Socket } from 'phoenix'
//import '../../../deps/torch/priv/static/torch.js'

import Pikaday from 'pikaday'

window.Socket = Socket;

// Function toggle inputs in filters:
$(".arrow").on("click", function() {
  var $this = $(this)
  var field = $this.closest($(".field"))

  field.find(".filter-options").toggle()
  // field.find("input").toggle()
  // field.find("select").toggle()

  field.find(".arrow-up").toggleClass("arrow-disabled")
  field.find(".arrow-down").toggleClass("arrow-disabled")
})

window.onload = () => {
  const slice = Array.prototype.slice
  /*
   * Prevent empty fields from being submitted, since this breaks Filtrex.
   */

  $('form').submit(function (e) {
    e.preventDefault()

    let disableFields = true

    slice.call(this.querySelectorAll('.field'), 0).forEach((field) => {
      let text = field.getElementsByTagName('label')[0] ? field.getElementsByTagName('label')[0].textContent : null
      let start = field.getElementsByClassName('start')[0]
      let end = field.getElementsByClassName('end')[0]

      if (start && end) {
        if (start.value === '' && end.value !== '') {
          window.alert(`Please select a start date for the ${text} field`)
          disableFields = false
        } else if (end.value === '' && start.value !== '') {
          window.alert(`Please select a end at date for the ${text} field`)
          disableFields = false
        }
      }
    })

    slice.call(this.querySelectorAll('input, select'), 0).forEach((field) => {
      if (field.value === '' && disableFields) {
        field.disabled = true
      }
    })

    if (disableFields) {
      e.target.submit()
    }
  })

  slice.call(document.querySelectorAll('select.filter-type'), 0).forEach((field) => {
    field.addEventListener('change', (e) => {
      const fieldParent = e.target.closest('.field')
      const input = fieldParent.querySelector('input')
      input.name = e.target.value
    })
  })

  slice.call(document.querySelectorAll('.datepicker'), 0).forEach((field) => {
    new Pikaday({field: field})
  })
}



// WEBPACK FOOTER //
// ./web/static/js/app.js